import Api from "..";
import TransmedAdmin from "../../dtos/transmed/process/admin";
import transform from "../../service/transform";

export default class TransmedAdminApi extends Api {
  constructor() {
    super("transmed/admin");
  }

  public async get(): Promise<TransmedAdmin> {
    return await transform(TransmedAdmin)((await super.get()).data);
  }
}
